import { Pipe, PipeTransform } from '@angular/core';
import { ConfigService } from '../services/config.service';
import { map, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { CurrencyPipe } from '@angular/common';

@Pipe({
    name: 'hlCurrency',
    standalone: true
})
export class HlCurrencyPipe implements PipeTransform {
  currency = this.configService.userConfig.pipe(
    map((config) => config?.currency ?? 'GBP')
  );

  constructor(
    private configService: ConfigService,
    private currencyPipe: CurrencyPipe
  ) {}

  transform(
    value: number | null | undefined,
    overRideCurrency?: string,
    conversionRate = 1,
    valueInPennies = true
  ): Observable<string | null | undefined> {
    if (!valueInPennies) {
      value = value ? value * 100 : value;
    }
    return this.currency.pipe(
      map((config) => overRideCurrency ?? config),
      map((currency) => {
        if (value === null || value === undefined) {
          return value as null | undefined;
        }
        return this.currencyPipe.transform(
          (value * conversionRate) / 100,
          currency,
          'symbol',
          '1.2-2'
        );
      })
    );
  }
}
